import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromUserRole from './store/reducers';
import { UserRoleComponent } from './user-role.component';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserRoleEffects } from './store/user-role.effects';
import { MultiSelectModule } from '../shared/efaact-primeng.module';

@NgModule({
  imports: [
    CommonModule
    , StoreModule.forFeature('user_role', fromUserRole.reducer)
    , EffectsModule.forFeature([UserRoleEffects])
    , EfaactMaterialModule
    , FormsModule
    , ReactiveFormsModule
    , BrowserAnimationsModule
    , MultiSelectModule
  ],
  declarations: [
    // UserRoleComponent
  ]

})
export class UserRoleModule { }
